import { useTranslation } from "react-i18next";

import PriceFormat from "../../../../../utils/priceFormat";
import { Callout, SectionCard } from "../Pill";

export interface ChecklistAnswers {
  ownerHasV5C: boolean;
  keysPresent: boolean;
  complete: boolean;
  wheelsOn: boolean;
  addressMatches: boolean;
}

export const emptyChecklist: ChecklistAnswers = {
  ownerHasV5C: false,
  keysPresent: false,
  complete: false,
  wheelsOn: false,
  addressMatches: false,
};

// What the agent confirms on the call. Recorded with the outcome; it doesn't change the price.
export default function ConfirmChecklist({
  answers,
  setAnswers,
  postcode,
  floor,
}: {
  answers: ChecklistAnswers;
  setAnswers: (answers: ChecklistAnswers) => void;
  postcode?: string | null;
  floor?: number | null;
}) {
  const { t } = useTranslation("leads");

  const items: { key: keyof ChecklistAnswers; label: string }[] = [
    { key: "ownerHasV5C", label: t("Owner is on the call and has the V5C") },
    { key: "keysPresent", label: t("Keys present") },
    { key: "complete", label: t("Complete — engine, gearbox, catalytic converter") },
    { key: "wheelsOn", label: t("Wheels on, can be winched") },
    {
      key: "addressMatches",
      label: postcode ? t("Collection address is {{postcode}}", { postcode }) : t("Collection address matches"),
    },
  ];
  const confirmed = items.filter((item) => answers[item.key]).length;

  return (
    <SectionCard title={t("Confirm on the call")} right={t("{{n}} of {{total}}", { n: confirmed, total: items.length })} className="flex-1 basis-72">
      <div className="flex flex-col gap-0.5 px-4 pb-3.5 pt-2.5 text-[13px]">
        {items.map((item) => (
          <label key={item.key} className="flex min-h-[44px] items-center gap-2.5 text-gray-800">
            <input
              type="checkbox"
              checked={answers[item.key]}
              onChange={(e) => setAnswers({ ...answers, [item.key]: e.target.checked })}
              className="h-[18px] w-[18px] rounded border-gray-300 text-green-600 focus:ring-green-600"
            />
            {item.label}
          </label>
        ))}
        <div className="mt-2">
          <Callout tone="amber">
            {floor !== null && floor !== undefined
              ? t("If any answer is no, the offer drops toward the {{floor}} floor.", { floor: PriceFormat(floor) })
              : t("If any answer is no, the offer drops toward the floor.")}
          </Callout>
        </div>
      </div>
    </SectionCard>
  );
}
